import { useEffect } from "react";
import { socketSend } from "../../lib/realtime";

const IDLE_MS = 10 * 60_000;
const HIDDEN_MS = 2 * 60_000;

/** Reports "away" after 10 minutes without input, or 2 minutes with the tab hidden; back to online on any activity. */
export function usePresenceReporter(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;
    let away = false;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const set = (next: boolean) => {
      if (next === away) return;
      away = next;
      socketSend({ type: "presence", away });
    };
    const arm = () => {
      clearTimeout(timer);
      timer = setTimeout(() => set(true), document.visibilityState === "hidden" ? HIDDEN_MS : IDLE_MS);
    };
    let last = 0;
    const active = () => {
      const now = Date.now();
      if (now - last < 5000 && !away) return; // cheap: pointer moves fire constantly
      last = now;
      if (document.visibilityState === "visible") set(false);
      arm();
    };
    const events = ["pointerdown", "keydown", "pointermove", "wheel", "focus"] as const;
    events.forEach((e) => window.addEventListener(e, active, { passive: true }));
    document.addEventListener("visibilitychange", active);
    arm();
    return () => {
      clearTimeout(timer);
      events.forEach((e) => window.removeEventListener(e, active));
      document.removeEventListener("visibilitychange", active);
    };
  }, [enabled]);
}
